import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { COOKIE_CONSENT_OPTION } from 'src/app/extensions/constants/cookieConstants';
import { CookieAPIService } from 'src/app/extensions/services/api/cookie-api.service';

@Component({
  selector: 'app-cookie-modal',
  templateUrl: './cookie-modal.component.html',
  styleUrl: './cookie-modal.component.scss',
  standalone: false,
})
export class CookieModalComponent implements OnInit {
  @Input() tenantId!: string;
  @Input() userId!: string;
  @Input() cookieMessageId!: string;

  message: string;
  cookieConsent: app.models.CookieConsentModel = {
    cookieMessageId: undefined,
    dictionaryCookieConsentCode: undefined,
    consentDate: undefined,
  };
  COOKIE_CONSENT_OPTION = COOKIE_CONSENT_OPTION;
  isCookieMessageExpanded: boolean = true;

  constructor(
    private _ngbActiveModal: NgbActiveModal,
    private _cookieAPIService: CookieAPIService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.cookieConsent.cookieMessageId = this.cookieMessageId;
  }

  saveUserConsent(selectedCodeOption: string) {
    this.cookieConsent.dictionaryCookieConsentCode = selectedCodeOption;
    this.cookieConsent.consentDate = new Date();
    this._cookieAPIService.saveCookieMessageConsent(this.cookieConsent).subscribe(result => {
      if (result.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('cookie.notification.cookieMessageConsentSaved'),
          this._translateService.instant('common.success')
        );

        this._ngbActiveModal.dismiss();
      } else {
        this._notificationService.showError(
          this._translateService.instant('cookie.notification.cookieMessageConsentSaveFailed'),
          this._translateService.instant('common.error')
        );
      }
    });
  }

  acceptAll() {
    this.saveUserConsent(COOKIE_CONSENT_OPTION.ALL);
  }

  toggleCookieMessageHandler() {
    this.isCookieMessageExpanded = !this.isCookieMessageExpanded;
    const modal = document.querySelector('.cookie-message-modal') as HTMLElement;
    modal.style = this.isCookieMessageExpanded ? '' : 'height: fit-content';
  }
}
